import { Service, WithContext } from 'schema-dts';
import MainJsonLD from './main';
import { SchemaIds } from './prepIds';

interface Props {
  services: { name: string; description?: string; image?: string }[];
  overrideJson?: string;
  ids: SchemaIds;
}

export function ServiceJsonLd({ services, overrideJson, ids }: Props) {
  if (overrideJson) return <MainJsonLD json={overrideJson} />;

  const { id, orgId } = ids;

  const jsonLd: WithContext<Service> = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': id,
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Services',
      itemListElement: services.map((service) => ({
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: service.name,
          description: service.description,
          image: service.image,
          provider: orgId
            ? {
                '@id': orgId,
              }
            : undefined,
        },
      })),
    },
  };

  return <MainJsonLD jsonLd={jsonLd} />;
}
